




import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'DigitalContent',
  setup() {
    return {
      pageTitle: 'デジタルフォト・ムービー',
    };
  },
});
